import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-signature-modal',
  templateUrl: './signature-modal.component.html',
  styleUrl: './signature-modal.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class SignatureModalComponent implements OnChanges {
  /** Show modal */
  @Input() showModal = false;
  /** Modal close emitter */
  @Output() isModalOpen = new EventEmitter<boolean>();
  /** Send signature Base64 */
  @Output() sendSignature: EventEmitter<any> = new EventEmitter<any>();
  /** Tabs signature */
  tabs = [
    {
      label: 'DASHBOARD.FORM GENERATED.TYPE',
    },
    {
      label: 'DASHBOARD.FORM GENERATED.DRAW',
    },
    {
      label: 'DASHBOARD.FORM GENERATED.UPLOAD',
    },
  ];
  /** active tab */
  activedTab = 0;
  /** Signature text */
  signatureText = '';
  /** Submitting flag */
  submitting = false;
  /** Get drawed signature */
  getSignature = false;
  /** Signature upload */
  signatureUpload = '';
  /** Error upload message */
  errorUploadMsg = '';

  /** On changes */
  ngOnChanges(changes: SimpleChanges): void {
    this.showModal = changes.showModal.currentValue;
  }

  /** Close modal */
  closeModal(): void {
    this.resetDataSignatures(0);
    this.showModal = false;
    this.isModalOpen.emit(false);
  }

  activeTab(idx: number): void {
    if (!this.submitting) {
      this.resetDataSignatures(idx);
    }
  }

  sendData(): void {
    if (this.activedTab === 0) {
      this.keyboardSignature();

      return;
    }

    if (this.activedTab === 1) {
      this.submitting = true;
      this.getSignature = true;

      return;
    }

    if (this.activedTab === 2) {
      const imageSignature = document.getElementById('signatureContainer') as HTMLImageElement;
      if (imageSignature) {
        imageSignature.src = this.signatureUpload;
        const widthImg = imageSignature.naturalWidth;
        const heightImg = imageSignature.naturalHeight;
        const widthP = (widthImg / heightImg) * 60;

        const imgTag = `<img src="${imageSignature.src}"  width="${widthP}px" height="60px">`;
        this.sendSignature.emit({
          imgTag,
          base64: this.signatureUpload,
        });
      }
      this.resetDataSignatures(0);

      return;
    }
  }

  resetDataSignatures(idx: number): void {
    this.signatureText = '';
    this.signatureUpload = '';
    this.getSignature = false;
    this.activedTab = idx;
  }

  keyboardSignature() {
    this.submitting = true;
    const canvas = document.getElementById('textCanvas') as HTMLCanvasElement | null;
    if (this.signatureText !== '' && canvas) {
      const tCtx = canvas?.getContext('2d') as CanvasRenderingContext2D;
      const font = '100pt "Palace"';

      tCtx.font = font;
      tCtx.canvas.width = tCtx.measureText(this.signatureText).width + 95;
      tCtx.font = font;
      tCtx.fillText(this.signatureText, 26, 90);
      tCtx.fillRect(0, 93, tCtx.canvas.width, 0);

      const imageSignature = document.getElementById('signatureContainer') as HTMLImageElement;
      if (imageSignature) {
        imageSignature.src = tCtx.canvas.toDataURL('image/png');
      }
      const widthP = (tCtx.canvas.width / tCtx.canvas.height) * 60;
      const base64 = tCtx.canvas.toDataURL('image/png');
      const imgTag = `<img src="${base64}" width="${widthP}px" height="60px" style="display: block; margin: 0px;"`;
      this.sendSignature.emit({
        imgTag,
        base64,
      });
      this.submitting = false;
      this.resetDataSignatures(0);
    }
  }

  onFileSelected(event: any): void {
    this.submitting = true;
    this.errorUploadMsg = '';
    const file: File = event;
    const fileTypeSplitted = file.type.split('/')[0];
    if (file.size > 1000000) {
      this.errorUploadMsg = 'DASHBOARD.FORM GENERATED.EXCEEDS_ALLOWED_SIZE';

      return;
    }
    if (file.type && fileTypeSplitted == 'image' && file.size < 1000000) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.signatureUpload = event.target.result;
        this.submitting = false;
      };
      reader.readAsDataURL(file);
    }
  }

  drawSignature(event: any) {
    const imageSignature = document.getElementById('signatureContainer') as HTMLImageElement;
    if (imageSignature) {
      imageSignature.src = event;
      const widthImg = imageSignature.naturalWidth;
      const heightImg = imageSignature.naturalHeight;
      const widthP = (widthImg / heightImg) * 60;

      const imgTag = `<img src="${imageSignature.src}"  width="${widthP}px" height="60px">`;
      this.sendSignature.emit({
        imgTag,
        base64: event,
      });
    }
    this.submitting = false;
    this.resetDataSignatures(0);
  }
}
